const theme3 = (data) => {
  const node = data.node;
  const title = node.title;
  const color = data.color;
  const date = new Date();
  const year = date.getFullYear(); //获取完整的年份(4位)
  const month = date.getMonth() + 1; //获取当前月份(0-11,0代表1月)
  const strDate = date.getDate(); // 获取当前日(1-31)

  return {
    id: "ttQTNxRVNL",
    elements: [
      {
        type: "text",
        id: "HhkliOrEd8",
        width: 276.5625,
        height: 41.40625,
        left: 361.6382053805774,
        top: 395.9696522309711,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fixedRatio: false,
        rotate: 0,
        content:
          '<p style="text-align: center;"><span style="font-size: 21.09375px;font-family: Microsoft Yahei;">汇报人：Chat PPT</span></p>',
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "text",
        id: "pXax4qRiut",
        width: 828.90625,
        height: 90.625,
        left: 85.37073490813648,
        top: 288.45866141732284,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fixedRatio: false,
        rotate: 0,
        content: `<p style="text-align: center;"><strong><span style="font-size: 53.90625px;"><span style="font-family: Microsoft Yahei;">${title}</span></span></strong></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "text",
        id: "VOYrqX1wNo",
        width: 372.65625,
        height: 41.40625,
        left: 313.81192585301835,
        top: 437.06332020997377,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fixedRatio: false,
        rotate: 0,
        content: `<p style="text-align: center;"><span style="font-size: 21.09375px;font-family: Microsoft Yahei;">${year}-${month}-${strDate}</span></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "shape",
        id: "ooiSPM1JFE",
        width: 48,
        height: 300,
        left: 826,
        top: 287.06332020997377,
        viewBox: [48, 300],
        path: "M 0 6 Q 0 0 6 0 L 42 0 Q 48 0 48 6 L 48 300 L 0 300 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: -90,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
        pathFormula: "roundRectSameSide",
        keypoint: 0.125,
      },
      {
        type: "shape",
        id: "MOn3PtyxKZ",
        width: 48,
        height: 300,
        left: 126,
        top: 287.06332020997377,
        viewBox: [48, 300],
        path: "M 0 6 Q 0 0 6 0 L 42 0 Q 48 0 48 6 L 48 300 L 0 300 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: -90,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
        pathFormula: "roundRectSameSide",
        keypoint: 0.125,
        flipH: false,
        flipV: true,
      },
      {
        type: "shape",
        id: "3WR747skir",
        width: 170.02001312335958,
        height: 170.02001312335958,
        left: 414.9899934383202,
        top: 95.28912401574803,
        viewBox: [170.02001312335958, 170.02001312335958],
        path: "M 25.843869868151817 0 L 144.17614325520776 0 Q 170.02001312335958 0 170.02001312335958 25.843869868151817 L 170.02001312335958 144.17614325520776 Q 170.02001312335958 170.02001312335958 144.17614325520776 170.02001312335958 L 25.843869868151817 170.02001312335958 Q 0 170.02001312335958 0 144.17614325520776 L 0 25.843869868151817 Q 0 0 25.843869868151817 0 Z",
        fill:  `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
        pathFormula: "roundRect",
        keypoint: 0.15200486927030502,
        gradient: {
          type: "linear",
          rotate: 0,
          color: [`${color}`, `${color}97`],
        },
      },
      {
        type: "shape",
        id: "MzQ-vNTwXU",
        width: 107.41002296587926,
        height: 95.72163278574337,
        left: 446.29502952755905,
        top: 133.84751091504404,
        viewBox: [1024, 1024],
        path: "M852.65066667 405.84533333C800.54044445 268.40177778 667.76177778 170.66666667 512.22755555 170.66666667S223.91466667 268.288 171.80444445 405.73155555C74.29688889 431.33155555 2.27555555 520.07822222 2.27555555 625.77777778c0 125.72444445 101.83111111 227.55555555 227.44177778 227.55555555h564.56533334C919.89333333 853.33333333 1021.72444445 751.50222222 1021.72444445 625.77777778c0-105.472-71.79377778-194.21866667-169.07377778-219.93244445z",
        fill: "#ffffff",
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
        special: true,
      },
    ],
    background: { type: "solid", color: "#ffffff" },
  };
};

export default theme3;
